import { Participant } from '@rtls/core/models/convoy/participant.model';
import { thingSummaryFactory } from '@rtls/core/models/thing/thing-summary.factory';
import * as Factory from 'factory.ts/lib';

export const participantFactory = Factory.makeFactory<Participant>({
	thing: Factory.each(() => thingSummaryFactory.build()),
});
